module.exports = __webpack_public_path__ + "img/avator.15ec2eb6.png";